import React from 'react';
import { useSpring, animated } from 'react-spring';

export default function ProgressCircle({ progress, color = 'white' }) {
    const { strokeDashoffset, opacity } = useSpring({
        strokeDashoffset: (1 - (progress || 0)) * 40 * 2 * Math.PI,
        opacity: isNaN(progress) ? 0 : 1,
    });

    return (
        <svg
            viewBox='-50 -50 100 100'
            style={{
                height: 80,
                width: 80,
            }}
        >
            <animated.circle
                strokeWidth={14}
                fill='none'
                opacity={opacity}
                stroke={'#ddd'}
                cx={0}
                cy={0}
                r={40}
                style={{
                    pointerEvents: 'none',
                }}
            />
            <animated.circle
                strokeWidth={10}
                fill='none'
                strokeDasharray={40 * 2 * Math.PI}
                strokeDashoffset={strokeDashoffset}
                opacity={opacity}
                stroke={color}
                cx={0}
                cy={0}
                r={40}
                style={{
                    pointerEvents: 'none',
                }}
            />
        </svg>
    );
}
